import { createApi } from '@reduxjs/toolkit/query/react';
import qs from 'qs';

import { axiosBaseQuery } from './axios-base-query';
interface PayloadType {
  id: string;
  labels: string;
  prompt: string;
  evaluate: string;
  returnValue: string;
  num_turns: number;
}

export const nodeGenAiTestApi = createApi({
  reducerPath: 'nodeGenAiTestApi',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/gen-ai-test' }),
  endpoints: (builder) => ({
    testGenAi: builder.mutation<{ id: string }, PayloadType[]>({
      query: (data) => {
        return {
          url: '/test-prompt',
          method: 'post',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          data: qs.stringify({ data }),
        };
      },
    }),
  }),
});
